module.exports = __webpack_public_path__ + "./fonts/MuseoSans_700.otf";